module.exports = "/assets/site/images/home.jpg?7092243491a1ecd61ed7c04a9fb13b01";